module.exports = __webpack_public_path__ + "img/close-filter-icon.4fbd60b3.svg";